import React from 'react';
export function PainSection() {
  return <section className="bg-blanco py-16 md:py-24 px-4" data-id="element-243">
      <div className="max-w-3xl mx-auto space-y-6 text-[16px] md:text-[18px] leading-[1.8] text-carbon" data-id="element-244">
        <p className="italic text-xl text-marron mb-8" data-id="element-245">Querida amiga,</p>

        <p data-id="element-246">Hay una luz en el baño que no perdona.</p>

        <p data-id="element-247">
          No la de la mañana, esa con la que te arreglas y sales corriendo al
          mundo con tu mejor cara. Hablo de la luz de las 11 de la noche. La
          implacable. La honesta. La que te muestra exactamente lo que hay
          detrás del maquillaje, detrás de la hidratante cara y detrás de todos
          los suplementos que has tomado fielmente cada mañana durante meses.
        </p>

        <p data-id="element-248">Y un día, bajo esa luz, lo viste.</p>

        <p data-id="element-249">
          No fue dramático. No fue una arruga de película de terror. Fue algo
          más sutil y más cruel: <strong data-id="element-250">una pérdida</strong>. Una pérdida de
          firmeza donde antes había contorno. Una sombra donde antes había luz.
          La piel que antes "rebotaba" cuando la presionabas con el dedo...
          simplemente cedía.
        </p>

        <p data-id="element-251">Quizás corriste a la farmacia al día siguiente.</p>

        <p data-id="element-252">
          Quizás compraste la crema más cara del estante. Quizás te suscribiste
          al colágeno en polvo de $60 al mes que recomendaba esa influencer que
          parece no envejecer nunca. Quizás pediste el sérum de retinol, la
          mascarilla de vitamina C, el contorno de ojos de última generación.
        </p>

        <p className="text-xl font-bold text-marron mt-8 mb-4" data-id="element-253">
          Y no pasó absolutamente nada.
        </p>

        <p data-id="element-254">O casi nada.</p>

        <p data-id="element-255">
          Tal vez tu piel se veía hidratada unas horas. Tal vez el sérum te daba
          esa sensación de suavidad que desaparecía al mediodía. Pero la firmeza
          real, esa que recuerdas de tus 30 años, seguía sin volver.
        </p>

        <p data-id="element-256">No fue tu culpa.</p>

        <p className="text-xl font-bold text-terracota mt-8" data-id="element-257">
          Fue que te vendieron la solución equivocada para el problema correcto.
        </p>

        <div className="my-12 border-t border-b border-marron/10 py-12" data-id="element-258">
          <h2 className="text-2xl md:text-3xl font-playfair font-bold text-marron mb-6 text-center" data-id="element-259">
            ❌ LA GRAN MENTIRA QUE TE COSTÓ CIENTOS DE DÓLARES
          </h2>

          <p data-id="element-260">
            Necesito decirte algo que la industria de los suplementos gasta
            millones en que nunca descubras.
          </p>

          <p className="text-xl font-bold text-rojo text-center my-6" data-id="element-261">
            El colágeno que tomas no llega a tu piel.
          </p>

          <p data-id="element-262">Así de simple. Así de brutal.</p>

          <p data-id="element-263">
            Cuando ingieres colágeno en polvo, tu sistema digestivo lo
            descompone en aminoácidos simples, exactamente igual que si hubieras
            comido un bistec o unas lentejas. Tu cuerpo decide soberanamente
            dónde usar esos aminoácidos, y generalmente los envía primero a los
            órganos internos, al sistema inmune, a los músculos.
          </p>

          <p className="font-bold text-center my-6" data-id="element-264">
            Tu cara es la última en la fila.
          </p>

          <p data-id="element-265">
            ¿Y las cremas? La molécula de colágeno es físicamente demasiado
            grande para penetrar la epidermis. Se queda en la superficie. Te
            hidrata. Pero no construye absolutamente nada en la dermis profunda,
            que es donde el colágeno real vive y donde se teje la firmeza que
            buscas.
          </p>

          <p data-id="element-266">
            Mientras tanto, después de los 35, tu cuerpo produce un 1% menos de
            colágeno cada año. Sin intervención real, ese déficit se acumula. Y
            la piel lo muestra. Primero en el espejo de las 11 PM. Luego en las
            fotos. Luego en el día a día.
          </p>
        </div>
      </div>
    </section>;
}